module.exports = __webpack_public_path__ + "img/website-bg.53684d5a.png";